module.exports = __webpack_public_path__ + "img/LUB00409.7a017350.png";